import { motion } from "framer-motion";
import { Crown } from "lucide-react";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ kicker, title, testid, align = "left" }) => (
  <Reveal className={`mb-16 ${align === "center" ? "text-center" : ""}`}>
    <div className={`flex items-center gap-4 ${align === "center" ? "justify-center" : ""}`}>
      <span className="h-px w-10 bg-[#D4AF37]/60" />
      <span className="font-script text-2xl md:text-3xl text-[#D4AF37]">{kicker}</span>
      <span className="h-px w-10 bg-[#D4AF37]/60" />
    </div>
    <h2
      data-testid={testid}
      className="font-display mt-4 text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight text-white"
    >
      {title}
    </h2>
    <Crown className={`mt-6 h-6 w-6 text-[#D4AF37]/70 ${align === "center" ? "mx-auto" : ""}`} strokeWidth={1} />
  </Reveal>
);
